<div class="balance-root" *ngIf="project">
  <div class="balance-second-header">
    <div class="header-first-part">
      <div class="image">
        <img src="/assets/images/balance_asset.png" />
      </div>
      <div class="separator"></div>
      <div class="project-location-root">
        <ng-container *ngIf="project._related.addresses[0]">
          <span class="project-location">{{ project._related.addresses[0].city + ' - ' + project._related.addresses[0].address_1 }}</span><br />
        </ng-container>
        <span class="quote_amount">Montant des devis : {{ totalInvoiceHistory | currency: 'EUR' }}</span>
      </div>
    </div>
    <div class="header-second-part">
      <div class="col-item stats">
        <span class="stats-left">{{ payments.length || 0 }}</span>
        <span class="stats-right">Échéances<br />À VENIR</span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="status === 'loading'">
    <div class="circle-container">
      <div class="circle-loader"></div>
    </div>
  </ng-container>

  <div class="balance-content" *ngIf="status === 'idle'">
    <div class="row quote-history-root">
      <div class="col-md-12">
        <div class="col-item quote-history">

          <!-- Echeances -->
          <div class="header">
            <span class="title">ÉCHÉANCES</span>
          </div>

          <div *ngFor="let payment of paymentsNotInvoiced" class="payment-wrapper">
            <img class="payment-status" src="assets/images/load-lightblue.svg" />
            <p class="payment-title">{{ payment.label }}</p>
            <div class="payment-content">
              <img src="assets/images/arrow-blue.svg" />
              <p>Facturation prévue le {{ payment.expected_date | date:'dd/MM' }}</p>
            </div>
            <div class="payment-total">
              {{ payment.amount | currency:'EUR' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
